import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { updateAddressObj } from '../../../../../reducers/_Pages/Public/radarSlice';

const UrlParamsHandler = () => {
  const { map, addressObj, coordinates, radius, modalPropertyId } = useSelector((state) => state.radar);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!addressObj.lat) return;

    setSearchParams(prev => {
      prev.set('lat', coordinates[1].toFixed(4));
      prev.set('lng', coordinates[0].toFixed(4));
      prev.set('radius', radius);
      modalPropertyId && prev.set('pid', modalPropertyId);
      return prev;
    });
  }, [addressObj.lat, coordinates, radius]);

  useEffect(() => {
    if (!modalPropertyId) {
      setSearchParams(prev => {
        prev.delete('pid');
        return prev;
      });
    } else {
      setSearchParams(prev => {
        prev.set('pid', modalPropertyId);
        return prev;
      });
    }
  }, [modalPropertyId]);

  useEffect(() => {
    if (!map?.current) return;
    
    const lat = searchParams.get('lat');
    const lng = searchParams.get('lng');
    const radius = searchParams.get('radius');

    if (!lat || !lng) return;
    
    const performGeocode = () => {
      const center = map.current.getCenter();
      const geocoder = new window.google.maps.Geocoder();
      
      geocoder.geocode({ location: center }, (results, status) => {
        if (status === 'OK' && results[0]) {
          dispatch(updateAddressObj({
            ...extractAddress(results[0]),
            lat: center.lat,
            lng: center.lng
          }));
          
          setSearchParams({});
        }
      });
    };

    // Check si Google est déjà chargé
    if (window.google && window.google.maps) {
      performGeocode();
    } else {
      window.initGoogleMaps = performGeocode;
      
      const checkInterval = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkInterval);
          performGeocode();
        }
      }, 100);
      
      // Clean après 10 secondes
      setTimeout(() => clearInterval(checkInterval), 10000);
      
      return () => clearInterval(checkInterval);
    }
  }, [map]);

  const extractAddress = (place) => {
    const addressComponents = place.address_components;
    const addressInfos = {
      address: place.formatted_address,
      street_number: addressComponents.find(t => t.types[0].includes('street_number'))?.long_name,
      street_name: addressComponents.find(t => t.types[0].includes('route'))?.long_name,
      city: addressComponents.find(t => t.types[0].includes('locality'))?.long_name,
      zip_code: addressComponents.find(t => t.types[0].includes('postal_code'))?.long_name,
      country_code: addressComponents.find(t => t.types[0].includes('country'))?.short_name,
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    };

    return addressInfos;
  };

  return null;
};

export default UrlParamsHandler;
